module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-barrel-shadow-10.0e6aa7b7.png";